import Checkbox from './Checkbox';
import ReduxFormCheckbox from './ReduxFormCheckbox';

export {
  Checkbox,
  ReduxFormCheckbox,
};



// WEBPACK FOOTER //
// /src/js/common/checkbox/index.js